module.exports = __webpack_public_path__ + "86347b09189a298fe0b8ed584fb17f67.svg";